module.exports = __webpack_public_path__ + "static/media/Call_Phone_Mobile_Selected.80245548.svg";